import axios from "axios";
import { getRotaPath } from "../lib/white-cache";

export const deleteExtraCalendarPointOfSale = async (
  id: string
): Promise<boolean> => {
  try {
    await axios.delete(`${getRotaPath()}/ExtraCalendarPointOfSale/${id}`);
    return true;
  } catch (error) {
    return false;
  }
};
